module.exports = __webpack_public_path__ + "static/media/claimopener.706fd979.svg";